/**
 * Scrolls to the top of the resources element during S&F filter/pagination
 *
 * When the filters or page of the results are updated, an ajax call is made
 * by Search and Filter Pro to load the next set of items. When that ajax call
 * is finished a javascript event 'sf:ajaxfinish' is fired. Here we tap into
 * that and scroll to the top of the resources, using the current height of the
 * sticky navigation as an offset.
 *
 * If the admin bar is present, that height is added to the offset.
 *
 * @type {jQuery|HTMLElement|*}
 * @package snaplogic
 */

let $ = jQuery;

const init = () => {
	$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
		let offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
		let adminBar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height'), 10);
		if (adminBar) {
			offset += adminBar;
		}
		$([document.documentElement, document.body]).animate({
			scrollTop: $('.resources').offset().top - offset
		}, 1000);
	})
}

document.addEventListener('DOMContentLoaded', () => {
	init();
})